import * as yup from 'yup';

import { attachmentsSchema } from 'src/components/attachment-gallery/validation/attachment-schema';

import { PatchAttachmentsFormFields } from '../constants/patch-attachments-form';

export const PatchAttachmentsSchema = yup.object({
    [PatchAttachmentsFormFields.Attachments]: attachmentsSchema,
});
